<template>
<main-content>
  <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
    <div class="d-flex align-items-center px-3">
      <div class="ml-auto">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 0 24 24"
            width="24px"
            fill="#00bea5"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
              d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z"
          />
        </svg>
        <span class="pr-2">تنظیمات درگاه فاکتور</span>
      </div>
      <div>
        <button
            type="button"
            class="btn btn-success px-4"
            style="border-radius: 10px"
            @click="submit"
        >
          به‌روزرسانی
        </button>
      </div>
    </div>
    <hr />
    <ps-form
        v-if="status !== 'loading'"
        :form_data="form_data"
    >
    </ps-form>
  </div>
</main-content>
</template>

<script>
import PSForm from "./components/psform";
import { mapGetters } from "vuex";
import { pardakhtShakhsiService } from "@/common/api.service";
import $ from "jquery";
import MainContent from '@/components/main-content.vue';
import { shopPardakhtShakhsiService } from "../../common/api.service";

export default {
  components: {
    "ps-form": PSForm,
    MainContent,
  },
  computed: {
    ...mapGetters("pardakhtShakhsi", ["form_data", "status"]),
    ...mapGetters("user", ["is_authenticated"]),
  },
  mounted() {
    this.$store.dispatch("pardakhtShakhsi/fetch");
  },
  methods: {
    submit(e) {
      let form = $("#ps_form");
      form.validate({
        rules: {
          wage_type: {
            required: true,
          },
          shop_id: {
            required: ({item}) => {
                console.log(item)
            },
          },
            callback_url: {
            required: this.form_data.after_success_pay_type === 2,
          }
        },
      });

      if (!form.valid()) {
        return;
      }

      let params = this.$store.getters["pardakhtShakhsi/form_data"];
      pardakhtShakhsiService
            .update(params)
            .then((response) => {
                this.showMsg($("#ps_form"), "success", response.data.message);
            })
            .catch(({ response }) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data);
                }
                this.showMsg(form, "danger", response.data.message);
            })
            .finally(() => {});
}
  },
};
</script>

<style>
</style>
